import React, { useState, useEffect } from "react";
//@ts-ignore
import { LanguageContext } from "../../../../../context/LanguageContext.jsx";
//@ts-ignore
import { dataList } from "../../../AdmMain.jsx";
import Page from "../../../../Atomic/template/PageTable";
import CommonControl from "../../../../Atomic/organism/CommonControl";
import SubNavi from "../../../../Atomic/molecules/SubNavi";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import axios from "../../../../../lib/axios";
//@ts-ignore
import { useAuth } from "../../../../../context/LoginContext";
//@ts-ignore
import TableAtom from "../../../../Atomic/organism/AtomTable";
import { filterData, inputChnage } from "../../../../Atomic/exFunc";
import Form from "../../../../Atomic/organism/FormAtom";
//@ts-ignore
import { subGadjet } from "../../../AdmMain.jsx";
// @ts-ignore
import { add_hyphen } from "../../../../../lib/common_func.js";
export default function WasteTable() {
  //@ts-ignore
  const { language } = React.useContext(LanguageContext);
  const navi = useNavigate();
  const [rawData, setRawData] = useState<any>([]);
  const { user } = useAuth();
  const inputRef = React.createRef<HTMLInputElement>();
  const [keyword, setKeyword] = useState("");
  const [data, setData] = useState<any>([]);

  // Function defines
  //===============================================================
  function translate(kr: string, en: string) {
    return language === "KOR" ? kr : en;
  }
  //===============================================================

  function move(e: any) {
    const i = e.instance.store.focus.rowIndex;
    if (i === undefined) {
      return;
    }
    const d_idx = e.instance.store.data.rawData[i].d_idx;
    const unitid = e.instance.store.data.rawData[i].unitid;
    if (!d_idx || !unitid) {
      return;
    }
    if (e.targetType !== "columnHeader") {
      navi(`/Adm/dev-table/edit`, {
        state: {
          idx: d_idx,
          unitid: unitid,
        },
      });
    }
  }

  function submitFun(e: any) {
    e.preventDefault();
    filterData(rawData, keyword, setData);
  }

  // Data define
  //===============================================================

  const columns: any = [
    {
      header: language === "KOR" ? "번호" : "Num",
      name: "rowKey" + 1,
      width: 70,
      align: "center",
      formatter: (name: any) => name.row.rowKey + 1,
    },
    {
      header: translate("단말기 UID", "Device UID"),
      name: "uid",
      align: "center",
    },
    {
      header: translate("단말기 S/N", "Device S/N"),
      name: "unit_sn",
      align: "center",
    },
    {
      header: translate("단말기 번호", "Device No"),
      name: "unitid",
      align: "center",
      formatter: (name: any) => add_hyphen(name.row.unitid),
    },
  ];

  const buttonData = [
    {
      labelKR: "전체목록",
      labelEN: "View All",
      classN: "white",
      clickFun: () => {
        setKeyword("");
      },
      position: "left",
      icon: false,
      iconClass: "",
    },
  ];

  const formData = {
    lan: language,
    inputId: "keyword",
    type: "text",
    placeKR: "검색어를 입력하세요",
    placeEN: "Please enter a search term",
    submitHandler: submitFun,
    filter: (e: any) => inputChnage(e, rawData, setData, setKeyword),
    myref: inputRef,
    option: undefined, // Make option undefined
    value: keyword,
  };

  // useEffect define
  //===============================================================

  useEffect(() => {
    axios.get(`/web/admin/waste/list?type=${user.type}`).then((res: any) => {
      setRawData(res.data);
    });
  }, [user]);

  useEffect(() => {
    if (rawData && keyword === "") {
      setData(rawData);
    } else if (rawData && keyword !== "") {
      filterData(rawData, keyword, setData);
    }
  }, [rawData, keyword]);

  return (
    <>
      <Page
        language={language}
        dataList={dataList}
        title={`${language === "KOR" ? "단말기 관리" : "Gadget management"}`}
        menu="/Adm/dev-table"
      >
        <SubNavi
          subDataList={subGadjet}
          language={language}
          navi={navi}
          classPath="/Adm/waste-table"
        />
        <Form formData={formData} inputRef={inputRef} />
        <TableAtom data={data} columns={columns} move={move} />
        <CommonControl buttonData={buttonData} language={language} />
      </Page>
    </>
  );
}
